module.exports = __webpack_public_path__ + "static/media/Navadhan_Logo.a8a12e6e.png";